var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTickWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10155_33184)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10155_33184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0194 2.58573L4.95834 10.6462C4.90415 10.7006 4.83974 10.7438 4.76882 10.7733C4.69789 10.8027 4.62185 10.8179 4.54505 10.8179C4.46825 10.8179 4.39221 10.8027 4.32129 10.7733C4.25037 10.7438 4.18596 10.7006 4.13176 10.6462L1.01443 7.52598C0.960229 7.47157 0.895821 7.4284 0.824898 7.39894C0.753975 7.36948 0.677933 7.35431 0.601135 7.35431C0.524337 7.35431 0.448294 7.36948 0.377371 7.39894C0.306448 7.4284 0.24204 7.47157 0.187843 7.52598C0.133432 7.58018 0.0902576 7.64459 0.0607983 7.71551C0.031339 7.78643 0.0161743 7.86247 0.0161743 7.93927C0.0161743 8.01607 0.031339 8.09211 0.0607983 8.16304C0.0902576 8.23396 0.133432 8.29837 0.187843 8.35256L3.30634 11.4705C3.63531 11.7988 4.08113 11.9833 4.54593 11.9833C5.01073 11.9833 5.45654 11.7988 5.78551 11.4705L13.846 3.41173C13.9003 3.35754 13.9434 3.29317 13.9728 3.2223C14.0022 3.15143 14.0174 3.07546 14.0174 2.99873C14.0174 2.922 14.0022 2.84603 13.9728 2.77516C13.9434 2.70429 13.9003 2.63992 13.846 2.58573C13.7918 2.53132 13.7274 2.48815 13.6565 2.45869C13.5856 2.42923 13.5095 2.41406 13.4327 2.41406C13.3559 2.41406 13.2799 2.42923 13.209 2.45869C13.138 2.48815 13.0736 2.53132 13.0194 2.58573Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10155_33184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10155_33184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTickWhite);
export default __webpack_public_path__ + "static/media/icon_tick_white.6a9128e622c48cd297ab62af0dfae7fb.svg";
export { ForwardRef as ReactComponent };